// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICipConfigMetricsResponseDto
 */
export interface ICipConfigMetricsResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof ICipConfigMetricsResponseDto
     */
    show_cip_metrics?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ICipConfigMetricsResponseDto
     */
    cip_account_closure_delay_days?: number;
}

/**
 * Check if a given object implements the ICipConfigMetricsResponseDto interface.
 */
export function instanceOfICipConfigMetricsResponseDto(value: object): value is ICipConfigMetricsResponseDto {
    return true;
}

export function ICipConfigMetricsResponseDtoFromJSON(json: any): ICipConfigMetricsResponseDto {
    return ICipConfigMetricsResponseDtoFromJSONTyped(json, false);
}

export function ICipConfigMetricsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICipConfigMetricsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'show_cip_metrics': json['show_cip_metrics'] == null ? undefined : json['show_cip_metrics'],
        'cip_account_closure_delay_days': json['cip_account_closure_delay_days'] == null ? undefined : json['cip_account_closure_delay_days'],
    };
}

export function ICipConfigMetricsResponseDtoToJSON(json: any): ICipConfigMetricsResponseDto {
    return ICipConfigMetricsResponseDtoToJSONTyped(json, false);
}

export function ICipConfigMetricsResponseDtoToJSONTyped(value?: ICipConfigMetricsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'show_cip_metrics': value['show_cip_metrics'],
        'cip_account_closure_delay_days': value['cip_account_closure_delay_days'],
    };
}

